<template>
<div class="page pageProduct">

</div>
</template>

<script>

export default {
    name: "ProductDetail",
    data() {

    },

    computed: {

    },
    mounted() {
        let pcFlag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i) ? false : true;
        if(pcFlag){
            window.location.href="https://auction.artron.net/paimai-"+ this.$route.params.id
        }else{
            window.location.href="https://m-auction.artron.net/trade/auction/detail/"+ this.$route.params.id
        }
       
      
    },
    methods: {
    },
    components: {
     
    }
}
</script>

<style lang="scss" scoped>

</style>
